/* eslint-disable react/no-array-index-key */
import OrderImage from '../../../../utilities/components/OrderImage';
import { calculateLineItemTotalDiscount, convertCentsToDollars, getAttributeValue } from '../../../../utilities/utils';
import {
  ORDER_STATUS_SHIPPED,
  ORDER_STATUS_RETURNED,
  ORDER_STATUS_AWAITING_FULFILLMENT,
  ORDER_LINE_ITEM_STATUS_INITIAL,
  ORDER_LINE_ITEM_STATUS_AWAITING,
  ORDER_LINE_ITEM_STATUS_PROCESSING,
  ORDER_LINE_ITEM_STATUS_FULFILLED,
  VARIANT_ATTRIBUTE_TITLE,
  FREE_LABEL,
} from './constants';

const ShipmentInfo = (props) => {
  const { shipments, order } = props;

  const returnedItemsIds = order.returnInfo.map(
    (returnItem) => returnItem.items.map((item) => item.lineItemId)).flat();

  const handleCreateShipments = () => {
    const awaitingFulfillmentShipments = shipments.map((shipment) => {
      const awaitingFulfillmentItems = shipment.filter(
        (shipItem) => !returnedItemsIds.includes(shipItem.id) && [
          ORDER_LINE_ITEM_STATUS_INITIAL,
          ORDER_LINE_ITEM_STATUS_AWAITING,
          ORDER_LINE_ITEM_STATUS_PROCESSING,
        ].includes(shipItem.custom?.fields?.fulfillmentStatus));
      return awaitingFulfillmentItems;
    }).flat();

    const shippedShipments = shipments.map((shipment) => {
      const shippedItems = shipment.filter(
        (shipItem) => !returnedItemsIds.includes(shipItem.id) &&
        shipItem.custom?.fields?.fulfillmentStatus === ORDER_LINE_ITEM_STATUS_FULFILLED);
      return shippedItems;
    }).flat();

    const returnedItems = order.lineItems.filter((item) => returnedItemsIds.includes(item.id));

    const shipmentsArray = [];
    if (awaitingFulfillmentShipments.length > 0) {
      shipmentsArray.push({
        shipmentStatus: ORDER_STATUS_AWAITING_FULFILLMENT,
        shipmentItems: awaitingFulfillmentShipments,
      });
    }
    if (shippedShipments.length > 0) {
      shipmentsArray.push({
        shipmentStatus: ORDER_STATUS_SHIPPED,
        shipmentItems: shippedShipments,
      });
    }
    if (returnedItems.length > 0) {
      shipmentsArray.push({ shipmentStatus: ORDER_STATUS_RETURNED, shipmentItems: returnedItems });
    }
    return shipmentsArray;
  };

  const updatedShipments = handleCreateShipments();

  return (
    <div className="shipments-container d-flex flex-column">
      {updatedShipments?.map((shipment, shipmentIndex) => (
        <div key={`shipment-${shipmentIndex}`} className="shipment-info ff-graphik m-b-40">
          <div className="m-b-xs">
            <div className="shipment-header bottom-border alternative d-flex align-items-center justify-content-between m-b-xs">
              <h3 className="shipments ff-wallop">
                Shipment
                {' '}
                {shipmentIndex + 1}
                {' '}
                of
                {' '}
                {updatedShipments.length}
              </h3>
            </div>
            {shipment.shipmentItems.map((product) => {
              const totalPriceCentAmount = product.totalPrice.centAmount;
              return (
                <div
                  key={product.id}
                  className="shipment-product-container m-b-xs"
                >
                  <div className="d-flex align-items-start">
                    <div className="img-container d-flex-center m-r-16">
                      <OrderImage
                        imgUrl={product.variant.images[0].url}
                        alt={product.name['en-US']}
                      />
                    </div>
                    <div className="d-flex flex-column">

                      <span className="m-b-8 c-purple fs-p3 fw-medium ff-graphik shipment-info-item">
                        {product.name['en-US']}
                      </span>
                      <span className="m-b-8 c-purple shipment-info-item fs-p3">
                        {getAttributeValue(product?.variant?.attributes, VARIANT_ATTRIBUTE_TITLE)}
                      </span>
                      <div
                        className="product-price"
                        data-testid="product-price"
                      >
                        {JSON.parse(product.custom.fields.discounts_json).length > 0 && (
                          <span className="price-original">
                            $
                            {
                              convertCentsToDollars(
                                totalPriceCentAmount +
                                calculateLineItemTotalDiscount(
                                  { quantity: product.quantity, custom: product.custom },
                                ),
                              )
                              }
                          </span>
                        )}
                        <span
                          className={
                            JSON.parse(product.custom.fields.discounts_json).length > 0
                              ? 'price-discount'
                              : ''
                          }
                        >
                          {
                            !parseFloat(convertCentsToDollars(totalPriceCentAmount)) ?
                              FREE_LABEL :
                              `$ ${convertCentsToDollars(totalPriceCentAmount)}`
                          }
                        </span>
                      </div>
                      <span className="m-b-8 c-purple fs-p3 fw-medium ff-graphik shipment-info-item">
                        Qty:
                        {' '}
                        {product.quantity}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShipmentInfo;
